import type { LDContext } from '../types/types';

/**
 * Check if a context has identifying name properties.
 * @param context - The context to check.
 * @returns true if the context has name, firstName+lastName, or email.
 */
export function contextHasName(context: LDContext): boolean {
  return !!(context.name || (context.firstName && context.lastName) || context.email);
}
